export default "__VITE_ASSET__rlMQ0_PS__"